export default function ChatDrawer({
  isOpen,
  onClose,
  messages,
  input,
  onInputChange,
  onSend,
  isLoading,
  chatEndRef,
}) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      width: "min(380px, 100vw)",
      background: "linear-gradient(180deg, #0f0f2e 0%, #1a1a4e 100%)",
      borderLeft: "1px solid rgba(255,255,255,0.12)",
      zIndex: 50,
      display: "flex",
      flexDirection: "column",
      animation: "slideUp 0.3s ease",
    }}>
      {/* Chat header */}
      <div style={{
        padding: "20px",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{
            width: "40px",
            height: "40px",
            borderRadius: "12px",
            background: "linear-gradient(135deg, #6C63FF, #a09bff)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
          }}>🤖</div>
          <div>
            <div style={{ color: "white", fontWeight: 800, fontSize: "16px" }}>AI Math Tutor</div>
            <div style={{ color: "#6C63FF", fontSize: "12px", fontWeight: 600 }}>● Online</div>
          </div>
        </div>
        <button
          onClick={onClose}
          style={{
            background: "rgba(255,255,255,0.08)",
            border: "none",
            borderRadius: "8px",
            color: "white",
            padding: "6px 12px",
            cursor: "pointer",
            fontSize: "16px",
          }}>✕</button>
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: "auto", padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
        {messages.map((msg, idx) => (
          <div key={idx} style={{
            display: "flex",
            justifyContent: msg.role === "user" ? "flex-end" : "flex-start",
            animation: "slideUp 0.2s ease",
          }}>
            <div style={{
              maxWidth: "85%",
              background: msg.role === "user"
                ? "linear-gradient(135deg, #6C63FF, #8b83ff)"
                : "rgba(255,255,255,0.08)",
              borderRadius: msg.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
              padding: "12px 16px",
              color: "white",
              fontSize: "14px",
              lineHeight: 1.6,
              border: msg.role !== "user" ? "1px solid rgba(255,255,255,0.08)" : "none",
              whiteSpace: "pre-wrap",
            }}>
              {msg.text}
            </div>
          </div>
        ))}
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <div style={{
              background: "rgba(255,255,255,0.08)",
              borderRadius: "18px 18px 18px 4px",
              padding: "12px 16px",
              border: "1px solid rgba(255,255,255,0.08)",
              display: "flex",
              gap: "6px",
              alignItems: "center",
            }}>
              {[0, 1, 2].map(i => (
                <div key={i} style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  background: "#6C63FF",
                  animation: `pulse 1s ${i * 0.2}s ease-in-out infinite`,
                }} />
              ))}
            </div>
          </div>
        )}
        <div ref={chatEndRef} />
      </div>

      {/* Quick prompts */}
      {messages.length <= 2 && (
        <div style={{ padding: "0 16px 12px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {["Can you explain the hint?", "I don't understand the question", "Show me step by step"].map(prompt => (
            <button
              key={prompt}
              onClick={() => onInputChange(prompt)}
              style={{
                background: "rgba(108, 99, 255, 0.15)",
                border: "1px solid rgba(108, 99, 255, 0.3)",
                borderRadius: "20px",
                padding: "6px 12px",
                color: "#a09bff",
                fontSize: "12px",
                fontWeight: 700,
                cursor: "pointer",
              }}>
              {prompt}
            </button>
          ))}
        </div>
      )}

      {/* Input */}
      <div style={{
        padding: "16px",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        display: "flex",
        gap: "10px",
      }}>
        <input
          value={input}
          onChange={e => onInputChange(e.target.value)}
          onKeyDown={e => e.key === "Enter" && onSend()}
          placeholder="Ask anything..."
          style={{
            flex: 1,
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: "12px",
            padding: "12px 16px",
            color: "white",
            fontSize: "14px",
            fontFamily: "'Nunito', sans-serif",
            outline: "none",
          }}
        />
        <button
          onClick={onSend}
          disabled={!input.trim() || isLoading}
          style={{
            background: input.trim() && !isLoading ? "#6C63FF" : "rgba(255,255,255,0.1)",
            border: "none",
            borderRadius: "12px",
            padding: "12px 16px",
            color: "white",
            fontSize: "18px",
            cursor: input.trim() && !isLoading ? "pointer" : "default",
            transition: "all 0.2s",
          }}>
          ➤
        </button>
      </div>
    </div>
  );
}
